import { render, staticRenderFns } from "./PersonalInfoCollectList.vue?vue&type=template&id=3670ebcb&scoped=true"
import script from "./PersonalInfoCollectList.vue?vue&type=script&lang=js"
export * from "./PersonalInfoCollectList.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoCollectList.vue?vue&type=style&index=0&id=3670ebcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670ebcb",
  null
  
)

export default component.exports